import React from 'react';
import { Button } from 'primereact/button';
import preistimgcard from '../../../assets/images/icon 9/Bhajan 4.png';
import styles from './PriestProviderCard.module.css';

const PriestProviderCard = ({ 
  provider, 
  isInCart, 
  onAddToCart, 
  onRemoveFromCart,
  serviceType,
  isAnotherPriestInCart // Add this prop to check if another priest is already in cart
}) => {
  console.log("testingdata", provider);
  
  // Format distance to show in km with 2 decimal places
  const formatDistance = (distanceInMeters) => {
    if (!distanceInMeters) return 'Distance not available';
    const distanceInKm = (distanceInMeters / 1000).toFixed(2);
    return `${distanceInKm} km`;
  };

  // Most concise version - just city and state
  const getShortAddress = (provider) => {
    const { city, state } = provider;
    
    if (city && state) {
      return ` ***, ${city}, ${state} `;
    } else if (city) {
      return ` *** ${city} (Area Only)`;
    } else if (state) {
      return ` ***, ${state} (Area Only)`;
    }
    
    return 'Location not specified';
  };

  // Get formatted address
  const formattedAddress = getShortAddress(provider);

  // Check if add button should be disabled
  const isAddDisabled = isAnotherPriestInCart && !isInCart;

  return (
    <div className={styles.quicklinkpriestCard}>
      <div className={styles.quicklinkpriestheader}>
        <div className={styles.yearsofexp}>
            <span className={styles.expcount}>10+ Years Of Experience</span>
            <span className={styles.rating}>4.5</span>
        </div>
        <div className={styles.quicklinkpriestDistance}>
            <span className="pi pi-map-marker"></span>
            <span>{formatDistance(provider.distanceInMeter)}</span>
          </div>
      </div>
      <div className={styles.quicklinkpriestContent}>
        {/* Left side - Details */}
        <div className={styles.quicklinkpriestDetails}>
          <h3 className={styles.quicklinkpriestName}>
            {provider.firstName} {provider.lastName || ''}
          </h3>
          
          <div className={styles.quicklinkpriestAddress}>
            <span className="pi pi-map-marker" style={{marginRight: '4px', fontSize: '0.8rem'}}></span>
            {formattedAddress}
          </div>
          <div className={styles.quicklinkpriestPrice}>
            ₹{provider.price || '2000'}
          </div>

          {/* Warning message */}
          {isAddDisabled && (
            <div className={styles.priestWarning}>
              Only one priest can be selected per event
            </div>
          )}
        </div>

        {/* Right side - Image with button */}
        <div className={styles.quicklinkpriestImageContainer}>
          <div className={styles.quicklinkpriestImage}>
            <img 
              src={provider.profileImage || preistimgcard} 
              alt={provider.firstName}
              onError={(e) => {
                e.target.src = preistimgcard;
              }}
            />
          </div>
          
          <div className={styles.quicklinkpriestOverlayButton}>
            {isInCart ? (
              <Button
                label="Remove"
                icon="pi pi-times"
                className={styles.quicklinkpriestRemoveButton}
                onClick={() => onRemoveFromCart(provider.id)}
              />
            ) : (
              <Button
                label="Add"
                icon="pi pi-plus"
                className={styles.quicklinkpriestAddButton}
                onClick={() => onAddToCart(provider)}
                disabled={isAddDisabled}
                tooltip={isAddDisabled ? "Only one priest can be selected per event" : ""}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PriestProviderCard;